export const getjQueryVersion = () => (window as any).jQuery?.fn?.jquery;
